/**
 * @file   src\components\Common\TextArea.js
 * @brief  This file is responsible for text area component
 * @date   June, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import React from "react";

const TextArea = (props) => {
  return (
    <div className="form-group">
      {props.label && <label>{props.label}</label>}
      <textarea
        className={
          props.className
            ? `form-control form-textarea ${props.className}`
            : "form-control form-textarea"
        }
        id={props.id}
        name={props.name}
        type={props.type}
        value={props.value}
        error={props.error}
        placeholder={props.placeholder}
        autoComplete={props.autoComplete}
        onChange={props.onChange}
        minLength={props.minLength}
        maxLength={props.maxLength}
        disabled={props.disabled}
        background-color={props.bgColor}
        ref={props.txtRef}
        onKeyDown={props.onKeyDown}
      />
      {props.errorMessage && props.errorMessage !== "" && (
        <span className="error-msg">{props.errorMessage}</span>
      )}
    </div>
  );
};

export default TextArea;
